import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { CTABand } from "@/components/CTABand";
import { ServiceCard } from "@/components/ServiceCard";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo title="Services" description="Website development, business management, SEO/SMO and digital marketing services from My Geeks LLC. See what is included, what is not, and request a quote." />
      <PageHeader overline="Services" title="What you can engage us for" lede="Five services, each described plainly: what is included, what is not, the typical delivery timeframe and how pricing works. Every engagement is quoted in writing." />

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-20">
        <div className="grid gap-8">
          {SERVICES.map((s, i) => <ServiceCard key={s.slug} service={s} index={i} />)}
        </div>
        <Reveal delay={0.1}>
          <div data-testid="services-pricing-note" className="mt-12 rounded-xl border-l-4 border-brand bg-brand-soft p-7 md:p-9">
            <p className="eyebrow">A note on pricing</p>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-700 md:text-base">
              We do not publish a standard price list because the cost of each engagement depends on its scope — the number of pages, the complexity of the work, the content you already have, and the length of any ongoing service. After a short discovery call we send a written quotation that states the price, what it covers, what it excludes, the delivery timeframe and the payment terms. There is no charge for a quotation, and no work begins until you accept it.
            </p>
          </div>
        </Reveal>
      </section>

      <CTABand title="Not sure which service fits?" text="Tell us what you are trying to achieve and we'll recommend the right starting point — in writing, with a price." />
    </div>
  );
}
